
import ShieldCross from "../../../assets/filled/ShieldCross.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ShieldCrossIcon({ className, dataTestid = "ShieldCrossIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ShieldCross data-testid={dataTestid} className={classes} {...rest} />
  );
}
